// extracted by mini-css-extract-plugin
export default {"projectNotesModal":"projectNotesModal__y2Whcs"};